const btnClearFilterExpiredServices = {
  Typography: 'Borrar todos'
};

export default btnClearFilterExpiredServices;
